<div class="phase-one-trial-date-container" [formGroup]="currentForm">
  <span class="phase-one-trial-date-text">Please indicate the date Phase 1 clinical trials began:</span>
  <div class="input-error" *ngIf="hasErrors()">
    This is a required field in the MM/DD/YYYY format.
  </div>
  <mat-form-field>
    <mat-label>Date</mat-label>
    <input matInput [matDatepicker]="picker" class="phase-one-trial-date-input" (dateInput)="updatePhase1ClinicalTrialStartDate(false, $event)" (dateChange)="updatePhase1ClinicalTrialStartDate(true, $event)" [value]="phase1ClinicalTrialStartDate">
    <mat-hint>MM/DD/YYYY</mat-hint>
    <mat-datepicker-toggle class="phase-one-trial-date-icon" matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
</div>
